import React, { useState } from 'react';
import VideoFullScreenModal from '../../../components/VideoFullScreenModal';
import './Videos.css'

const VideoFree = () => {

    let [isOpen, setIsOpen] = useState(false)
    const [vide, setVideo] = useState(null)

    function closeModal() {
        setIsOpen(false)
    }

    function openModal() {
        setIsOpen(true)
    }

    // const handleVideo = (video) => {
    //     openModal()
    //     setVideo(video)
    // }

    const videos = [
        {
            image: "https://img.freepik.com/free-photo/businesspeople-working-finance-accounting-analyze-financi_74952-1411.jpg?size=626&ext=jpg&ga=GA1.1.1817583408.1678734770&semt=ais",
            videoUrl: "https://www.youtube.com/embed/OTaLHFX-31s"
        },
        {
            image: "https://img.freepik.com/free-photo/laptop-with-book_1134-348.jpg?size=626&ext=jpg&ga=GA1.2.1817583408.1678734770&semt=ais",
            videoUrl: "https://www.youtube.com/embed/dZ4V-LOwZSo"
        },
        {
            image: "https://img.freepik.com/free-photo/data-information-report-statistics-strategy-concept_53876-124952.jpg?size=626&ext=jpg&ga=GA1.1.1817583408.1678734770&semt=ais",
            videoUrl: "https://www.youtube.com/embed/v1OwnHKoXNw"
        },
        {
            image: "https://img.freepik.com/free-photo/business-people-working-laptop-meeting_53876-40326.jpg?size=626&ext=jpg&ga=GA1.1.1817583408.1678734770&semt=ais",
            videoUrl: "https://www.youtube.com/embed/UMUE-uj0b_I"
        }
    ]


    return (
        <div className='bg-color w-full'>
            <div className=' px-5 xl:px-0 py-11 md:py-16 max-w-6xl mx-auto'>
                <div class="md:flex md:items-center md:justify-between">
                    <div>
                        <h1 class="text-3xl font-semibold text-gray-800 capitalize lg:text-4xl dark:text-white">
                            Explore Free Videos
                        </h1>
                        <p className='text-gray-500 pt-2'>Discover Your Perfect Program in Our Courses.</p>
                    </div>

                    <div class="mt-5 md:mt-0">
                        <h3 className='text-lg  cursor-pointer'>Browse All <i class="fa-solid fa-angle-right"></i></h3>
                    </div>
                </div>
                <div className='grid grid-cols-1 gap-8 mt-9 xl:gap-12 lg:grid-cols-2'>
                    {
                        videos.map(video =>
                            <div onClick={openModal}
                                className='relative'
                            >
                                <img
                                    onClick={() => setVideo(video)}
                                    className='min-w-full h-64 md:h-72 rounded-xl overflow-hidden cursor-pointer '
                                    src={video.image}
                                />
                                <div className='w-full absolute top-0 bottom-0 flex items-center justify-center divColor rounded-xl'>
                                    <span class="flex items-center justify-center h-16 w-16">
                                        <span class="animate-ping absolute inline-flex h-11 w-11 rounded-full bg-blue-400 opacity-75"></span>
                                        <span class="relative inline-flex rounded-full h-11 w-11 bg-white text-blue-500 flex items-center justify-center text-xl"><i class="fa-solid fa-play"></i></span>
                                    </span>
                                </div>
                            </div> 
                        )
                    }
                </div>
            </div>
            <VideoFullScreenModal
                vide={vide}
                setVIdeo={setVideo}
                isOpen={isOpen}
                openModal={openModal}
                closeModal={closeModal}
            />
        </div>
    );
};

export default VideoFree;